import { NPS_TYPE } from '../../../components/StatelessComponent/SingleFilter/NPSFilter/NPSFilterType';
import type { IntermediateFormat } from '../../../domains/global-filters/model/IntermediateFormat';
import type { QueryFormatFilter } from '../../../domains/global-filters/model/QueryFormat';
import {
  QueryListOperandEnum,
  QueryMapOperandEnum,
  QueryKeyEnum,
} from '../../../domains/global-filters/model/QueryFormat';

const NPS_TYPE_WEIGHTS: { [key in NPS_TYPE]: number[] } = {
  [NPS_TYPE.PROMOTERS]: [9, 10],
  [NPS_TYPE.PASSIVES]: [7, 8],
  [NPS_TYPE.DETRACTORS]: [0, 1, 2, 3, 4, 5, 6],
};

export function fromUiToQueryFormat(uiValue?: NPS_TYPE[]): QueryFormatFilter {
  if (!uiValue) {
    return {};
  }
  const list = uiValue.map((item) => {
    return NPS_TYPE_WEIGHTS[item].map((value) => {
      return {
        [QueryMapOperandEnum.EQUAL]: {
          [QueryKeyEnum.nps]: `poll.q.t:nps.a:${value}`,
        },
      };
    });
  });

  return { [QueryListOperandEnum.OR]: list.flat() };
}

export function fromIntermediateToUiFormat(intermediateValue: IntermediateFormat): NPS_TYPE[] {
  const list = (intermediateValue.value as string[]).map((item) => {
    if (item.search(/(9|10)/i) > -1) {
      return NPS_TYPE.PROMOTERS;
    }
    if (item.search(/(7|8)/i) > -1) {
      return NPS_TYPE.PASSIVES;
    }
    return NPS_TYPE.DETRACTORS;
  });
  return Array.from(new Set(list));
}
